import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-items: center;
  text-align: center;
  align-items: center;
`
